const routes = [
  {
    path: 'equidistant-objects-with-css',
    name: 'equidistant-objects-with-css',
    component: () => import(/* webpackChunkName: "equidistant-objects-with-css" */ '@/modules/equidistant-objects-with-css/index.vue')
  },
];

export default routes;